<template>
	<div>
		<div class="filter-inline-panel cle">
			<div class="filter-panel"></div>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('coupon_index.name')"></el-table-column>
			<el-table-column prop="credit_amount" align="center" :label="$t('coupon_index.credit_amount')">
				<template slot-scope="{row}">
					<p v-if="row.coupon_type==1">￥{{row.price}}</p>
					<p v-if="row.coupon_type==2">{{row.discount}}%</p>
				</template>
			</el-table-column>
			<el-table-column prop="menkan" align="center" :label="$t('coupon_index.menkan')"></el-table-column>
			<el-table-column prop="get_type" align="center" :label="$t('coupon_index.get_type')" :formatter="formatter"></el-table-column>
			<el-table-column prop="coupon_type" align="center" :label="$t('coupon_index.coupon_type')" :formatter="formatter"></el-table-column>
			<el-table-column prop="is_diejia" align="center" :label="$t('coupon_index.superposition')" :formatter="formatter"></el-table-column>
			<el-table-column prop="all_times" align="center" :label="$t('coupon_index.all_times')"></el-table-column>
			<el-table-column prop="code" align="center" :label="$t('coupon_index.code')">
				<template slot-scope="{row}">
					<p v-if="row.get_type==1">{{row.code}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="time" align="center" :label="$t('coupon_index.time')+' / '+$t('coupon_index.length')">
				<template slot-scope="{row}">
					<p v-if="row.time_type==2">{{getTime_us(row.start_time,'mmddyyyyampm')}} <br> {{getTime_us(row.end_time,'mmddyyyyampm')}}</p>
					<p v-else>{{row.length}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="is_up" align="center" :label="$t('coupon_index.status')" :formatter="formatter"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="240">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('history')" @click="history(scope.row)">{{$t('index.history')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" width="1200px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('coupon_index.name')" prop="name_cn">
							<el-input v-model="editForm.name_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('coupon_index.name')" prop="name">
							<el-input v-model="editForm.name" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('coupon_index.get_type')" prop="get_type" data-name="领取方式">
							<el-select v-model="editForm.get_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_COLLECTION_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="6" v-if="editForm.get_type=='1'">
						<el-form-item :label="$t('coupon_index.trigger_type')" prop="trigger_type" data-name="领取触发类型">
							<el-select v-model="editForm.trigger_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in COUPON_TRIGGER_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row :gutter="20">
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.is_discount')" prop="suanqian" data-name="比例折扣">
							<el-select v-model="editForm.suanqian" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?'是':'YES'" :value="1"></el-option>
								<el-option :label="lang=='cn'?'否':'NO'" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.coupon_type')" prop="coupon_type" data-name="优惠券类型">
							<el-select v-model="editForm.coupon_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.coupon_type=='1'">
						<el-form-item :label="$t('coupon_index.credit_amount')" prop="price" data-name="抵值金额">
							<el-input v-model="editForm.price" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off">
								<template slot="prepend">￥</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.coupon_type=='2'">
						<el-form-item :label="$t('coupon_index.discount')" prop="discount" data-name="抵值金额">
							<el-input v-model="editForm.discount" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.time_type')" prop="time_type" data-name="时间类型">
							<el-select v-model="editForm.time_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_TIME_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.time_type=='1'">
						<el-form-item :label="$t('coupon_index.length')" prop="length" data-name="时长">
							<el-input-number v-model="editForm.length" :min="1"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-if="editForm.time_type=='2'">
						<el-form-item :label="$t('coupon_index.time')" prop="time" data-name="时间区间">
							<el-date-picker v-model="editForm.time" type="datetimerange" class="w100" value-format="timestamp" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.superposition')" prop="is_diejia" data-name="叠加">
							<el-select v-model="editForm.is_diejia" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_OVERLAY" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="4" v-if="editForm.is_diejia==1">
						<el-form-item :label="$t('coupon_index.no_diejia')" prop="no_diejia" data-name="不叠加">
							<el-select v-model="editForm.no_diejia" class="w100" clearable filterable multiple :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-for="(item,index) in ListNoPage" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="4">
						<el-form-item :label="$t('coupon_index.binding_type')" prop="bind_type" data-name="绑定类型">
							<el-select v-model="editForm.bind_type" class="w100" clearable @change="binding_list_f" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?'不限':'unlimited'" :value="0"></el-option>
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_BINDING_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.bind_type">
						<el-form-item :label="$t('coupon_index.is_exclude')" prop="is_exclude" data-name="是否包括">
							<el-select v-model="editForm.is_exclude" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-for="(item,index) in is_use" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-if="editForm.bind_type=='7'||editForm.bind_type=='8'" data-name="常规课列表||夏令营列表">
						<el-form-item :label="$t('coupon_index.binding')" prop="bind_id" data-name="绑定">
							<el-select v-model="editForm.bind_id" class="w100" clearable filterable multiple :placeholder="$t('index.select')">
								<el-option :label="(lang=='cn'?item.theme_cn:item.theme)+'（ID:'+item.id+'）'" :value="String(item.id)" v-for="(item,index) in BINDING_LIST" :key="index"> {{lang=='cn'?item.theme_cn:item.theme}} （ID:{{item.id}}） </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-else-if="editForm.bind_type=='1'||editForm.bind_type=='2'||editForm.bind_type=='3'" data-name="分类列表">
						<el-form-item :label="$t('coupon_index.binding')" prop="aaa" data-name="绑定">
							<el-cascader v-model="editForm.aaa" :props="props" clearable class="w100" :options="BINDING_LIST"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-else-if="editForm.bind_type=='9'" data-name="学期">
						<el-form-item :label="$t('coupon_index.binding')" prop="aaa" data-name="绑定">
							<el-select v-model="editForm.bind_id" class="w100" clearable multiple :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="String(item.code)" v-for="(item,index) in SESSION_ARR" :key="index"> {{lang=='cn'?item.name_cn:item.name}}</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('coupon_index.service_conditions')" prop="use_type" data-name="使用条件">
							<el-select v-model="editForm.use_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_USAGE_CONDITIONS" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="editForm.use_type==1">
						<el-form-item :label="$t('coupon_index.menkan')" prop="menkan" data-name="满减金额">
							<el-input v-model="editForm.menkan" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off">
								<template slot="prepend">￥</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('coupon_index.all_times')" prop="all_times" data-name="使用次数">
							<el-input-number v-model="editForm.all_times" :min="0" :precision="0" :step="1"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('coupon_index.status')" prop="is_up" data-name="状态">
							<el-select v-model="editForm.is_up" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="Number(item.code)" v-for="(item,index) in COUPON_STATUS" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('coupon_index.shuoming')" prop="shuoming_cn" data-name="说明">
							<el-input v-model="editForm.shuoming_cn" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('coupon_index.shuoming')" prop="shuoming" data-name="说明">
							<el-input v-model="editForm.shuoming" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$t('index.history')" width="1200px" :close-on-click-modal="false" :visible="history_is" @close="history_is = false">
			<div class="filter-inline-panel cle">
				<div class="list-opinion fr">
					<el-button type="primary" v-if="data_data.get_type==1" size="mini" @click="del_del()">{{$t('index.del')}}</el-button>
					<!-- <el-button type="primary" size="mini" @click="exportCouponRecord()">{{$t('index.export')}}</el-button> -->
				</div>
			</div>
			<el-table :data="history_list" border size="mini" @selection-change="handleSelectionChange">
				<el-table-column type="selection" align="center" width="40" :key="0" v-if="data_data.get_type==1" :selectable="checkSelectable"></el-table-column>
				<el-table-column prop="order_id" align="center" :label="$t('coupon_index.order')" :key="1" v-if="data_data.get_type==2"></el-table-column>
				<el-table-column prop="user_id" align="center" :label="$t('coupon_index.user_id')" :key="10"></el-table-column>
				<el-table-column prop="user_tel" align="center" :label="$t('coupon_index.user_tel')" :key="20"></el-table-column>
				<!-- <el-table-column prop="user_name" align="center" :label="$t('coupon_index.user_name')" :key="20"></el-table-column> -->
				<el-table-column prop="create_time" align="center" :label="$t('coupon_index.use_time')" :key="30" v-if="data_data.get_type==2">
					<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyyampm')}}</template>
				</el-table-column>
				<el-table-column prop="create_time" align="center" :label="$t('coupon_index.get_time')" :key="40" v-if="data_data.get_type==1">
					<template slot-scope="{row}">{{getTime_us(row.create_time,'mmddyyyyampm')}}</template>
				</el-table-column>
				<el-table-column prop="get_way" align="center" :label="$t('coupon_index.get_type')" :key="50" :formatter="formatter_f" v-if="data_data.get_type==1"></el-table-column>
				<el-table-column prop="remark" align="center" :label="$t('parent_index.remarks')" :key="51"></el-table-column>
				<el-table-column prop="is_used" align="center" :label="$t('coupon_index.is_use')" :key="60" v-if="data_data.get_type==1">
					<template slot-scope="{row}">
						<span v-if="lang=='cn'">{{is_use[row.is_used].name_cn}}</span>
						<span v-else>{{is_use[row.is_used].name}}</span>
						<span v-if="row.is_used==1">{{row.order_id}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		editFormRules() {
			return {
				name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.en') + this.$t('coupon_index.name'),
					trigger: 'blur'
				}],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.cn') + this.$t('coupon_index.name'),
					trigger: 'blur'
				}],
				get_type: [{
					required: true,
					message: this.$t('index.select') + this.$t('coupon_index.get_type'),
					trigger: 'chang'
				}],
				coupon_type: [{
					required: true,
					message: this.$t('index.select') + this.$t('coupon_index.coupon_type'),
					trigger: 'chang'
				}],
				discount: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('coupon_index.discount'),
					trigger: 'blur'
				}],
				price: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('coupon_index.credit_amount'),
					trigger: 'blur'
				}],
				menkan: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('coupon_index.menkan'),
					trigger: 'blur'
				}],
				time: [{
					required: true,
					message: this.$t('index.select') + this.$t('coupon_index.time'),
					trigger: 'chang'
				}],
				is_diejia: [{
					required: true,
					message: this.$t('index.select') + this.$t('coupon_index.superposition'),
					trigger: 'chang'
				}],
			}
		},
		props() {
			return {
				value: 'id',
				label: this.lang == 'cn' ? 'name_cn' : 'name',
				multiple: true,
			}
		},
		props_() {
			return {
				value: 'id',
				label: this.lang == 'cn' ? 'name_cn' : 'name',
				multiple: true,
			}
		},
	},
	data() {
		return {
			list: [],
			editFormVisible: false,
			editForm: {},
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			COUPON_TYPE: [],
			COUPON_COLLECTION_TYPE: [],
			COUPON_OVERLAY: [],
			COUPON_BINDING_TYPE: [],
			COUPON_TRIGGER_TYPE: [],
			COUPON_USAGE_CONDITIONS: [],
			COUPON_TIME_TYPE: [],
			COUPON_STATUS: [],
			BINDING_LIST: [],
			cate: [],
			course: [],
			camp: [],
			cascaderKey: 1,
			history_is:false,
			history_list:[],
			data_data:{},
			ids:[],
			ListNoPage:[],
			is_use:[
				{
					id:0,
					code:"0",
					name:"NO",
					name_cn:"否",
				},
				{
					id:1,
					code:"1",
					name:"YES",
					name_cn:"是",
				},
			]
		}
	},
	watch: {
		BINDING_LIST() {
			this.cascaderKey++
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.getBandListByBindType('course');
		this.getBandListByBindType('camp');
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: "COUPON_TYPE,COUPON_COLLECTION_TYPE,COUPON_OVERLAY,COUPON_BINDING_TYPE,COUPON_TRIGGER_TYPE,COUPON_USAGE_CONDITIONS,COUPON_TIME_TYPE,COUPON_STATUS,SESSION_ARR"
			};
			this_.$post(url, datas).then((res) => {
				this_.COUPON_TYPE = res.COUPON_TYPE;
				this_.COUPON_COLLECTION_TYPE = res.COUPON_COLLECTION_TYPE;
				this_.COUPON_OVERLAY = res.COUPON_OVERLAY;
				this_.COUPON_BINDING_TYPE = res.COUPON_BINDING_TYPE;
				this_.COUPON_TRIGGER_TYPE = res.COUPON_TRIGGER_TYPE;
				this_.COUPON_USAGE_CONDITIONS = res.COUPON_USAGE_CONDITIONS;
				this_.COUPON_TIME_TYPE = res.COUPON_TIME_TYPE;
				this_.COUPON_STATUS = res.COUPON_STATUS;
				this_.SESSION_ARR = res.SESSION_ARR;
			})
			var url = "cateOption";
			var datas = {
				type: '1',
			}
			this_.$post(url, datas).then((res) => {
				this_.cate = res.show;
			})
			var url = "cateOption";
			var datas = {
				type: '1',
			}
			this_.$post('CouponListNoPage', {is_diejia:1}).then((res) => {
				this_.ListNoPage = res;
				console.log(this_.ListNoPage)
			})
		},
		// 常规课和夏令营列表
		getBandListByBindType(type) {
			var this_ = this;
			var url = "getBandListByBindType";
			var datas = {
				type: type,
			}
			this_.$post(url, datas).then((res) => {
				var list = res;
				if (type == 'camp') {
					list.forEach(function (e, i) {
						e['theme'] = e.title;
						e['theme_cn'] = e.title_cn;
					});
				}
				this_[type] = list;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "CouponList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		binding_list_f(e) {
			if (e == 7) {
				this.BINDING_LIST = this.course;
			} else if (e == 8) {
				this.BINDING_LIST = this.camp;
			}else if(e==9){

			} else {
				var list = this.list_for(this.cate, e);
				this.BINDING_LIST = list;
			}
			this.editForm.aaa = [];
			this.editForm.bind_id = [];
		},
		list_for(list, s) {
			var this_ = this;
			var array = [];
			list.forEach(function (e, i) {
				var boj = {
					id: e.id,
					name: e.name,
					name_cn: e.name_cn,
				}
				if (e.level < s) {
					boj['children'] = this_.list_for(e.children, s);
				}
				array[i] = boj;
			});
			return array
		},
		add(data) {
			if (data) {
				var editForm = JSON.parse(JSON.stringify(data));
				this.editForm = JSON.parse(JSON.stringify(data));
				this.binding_list_f(editForm.bind_type);
				var time = [];
				if (editForm.start_time && editForm.end_time) {
					time[0] = editForm.start_time * 1000;
					time[1] = editForm.end_time * 1000;
				}
				this.$set(this.editForm, 'time', time);
				this.editForm['aaa'] = JSON.parse(editForm.aaa);
				if (editForm.bind_id) {
					this.editForm['bind_id'] = editForm.bind_id.split(',');
				} else {
					this.editForm['bind_id'] = []
				}
				if (editForm.no_diejia) {
					this.editForm['no_diejia'] = editForm.no_diejia.split(',').map(Number);
				} else {
					this.editForm['no_diejia'] = []
				}
			} else {
				this.editForm = {
					time_type: 0, //时间类型
					length: 1, // 时长
					time: [],
					start_time: '', //有效期开始时间
					end_time: '', //有效期结束时间
					menkan: '', //门槛
					discount: '', //折扣值
					price: '', //抵值金额
					coupon_type: '', //优惠券类型
					get_type: '', //领取类型
					is_diejia: '', //是否可叠加
					bind_type: 0, // 绑定谁
					aaa: [], //绑定的ID
					bind_id: null, //绑定的ID
					trigger_type: '', //触发条件
					use_type: 1,
					all_times: 1, //总使用次数
					name: '', //名称
					name_cn: '', //名称
					is_up: 1, //状态
					shuoming: '', //说明
					shuoming_cn: '', //说明
					is_exclude:0, //包括
					suanqian:0, //包括
					no_diejia:[],//不叠加
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						name: this_.editForm.name,
						name_cn: this_.editForm.name_cn,
						coupon_type: this_.editForm.coupon_type,
						discount: this_.editForm.discount,
						price: this_.editForm.price,
						is_diejia: this_.editForm.is_diejia,
						get_type: this_.editForm.get_type,
						time_type: this_.editForm.time_type,
						bind_type: this_.editForm.bind_type,
						use_type: this_.editForm.use_type,
						all_times: this_.editForm.all_times,
						is_up: this_.editForm.is_up,
						shuoming: this_.editForm.shuoming,
						shuoming_cn: this_.editForm.shuoming_cn,
						is_exclude: this_.editForm.is_exclude,
						suanqian: this_.editForm.suanqian,
						no_diejia: this_.editForm.no_diejia||'',
					}
					if (datas.time_type == '1') {
						datas['length'] = this_.editForm.length;
					} else if (datas.time_type == '2') {
						datas['start_time'] = Math.round(this_.editForm.time[0] / 1000);
						datas['end_time'] = Math.round(this_.editForm.time[1] / 1000);
					}
					if (datas.use_type == '1') {
						datas['menkan'] = this_.editForm.menkan;
					}
					if (datas.get_type == '1') {
						datas['trigger_type'] = this_.editForm.trigger_type;
					}
					if (datas.no_diejia&&datas.no_diejia.length>0) {
						datas['no_diejia'] = this_.editForm.no_diejia.join(',');
					}
					if (datas.bind_type == '7' || datas.bind_type == '8' || datas.bind_type == '9') {
						datas['bind_id'] = this_.editForm.bind_id.join(',');
					} else if (this_.editForm.aaa && this_.editForm.aaa.length) {
						var bind_id = [];
						var aaa = JSON.parse(JSON.stringify(this_.editForm.aaa));
						aaa.forEach(function (e, i) {
							bind_id[i] = e[e.length - 1];
						});
						datas['bind_id'] = bind_id.join(',');
						datas['aaa'] = JSON.stringify(aaa);
					}
					var url = "CouponAction";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "CouponDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		history(data){
			var this_ = this;
			this_.data_data=data;
			var url = "CouponRecord";
			var datas = {
				id: data.id,
			};
			this_.$post(url, datas).then((res) => {
				this_.history_list = res;
				this_.history_is=true;
			})
		},
		// 表格是否可以被选中回调
		checkSelectable(row, index){
			return row.is_used==0?true:false;
		},
		handleSelectionChange(data){
			var ids=[];
			data.forEach(function(e,i) {
				ids[i]=e.id;
			});
			this.ids=ids;
		},
		del_del(){
			var this_ = this;
			if (this_.ids&&this_.ids.length) {
				var url = "deletePrivateUserCoupon";
				var datas={
					id:this_.ids
				}

				this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
					this_.$post(url,datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.history(this_.data_data);
					})
				})
			}else{
				this_.$message.success(this_.$t('index.please_check'));
			}
		},
		formatter(w, s, d) {
			var this_ = this;
			var list = [];
			var name = '';
			if (s.property == 'is_diejia') {
				list = this.COUPON_OVERLAY;
			} else if (s.property == 'coupon_type') {
				list = this.COUPON_TYPE;
			} else if (s.property == 'get_type') {
				list = this.COUPON_COLLECTION_TYPE;
			} else if (s.property == 'is_up') {
				list = this.COUPON_STATUS;
			}
			list.forEach(function (e, i) {
				if (e.code == d) {
					name = this_.lang == 'cn' ? e.name_cn : e.name;
				}
			});
			return name
		},
		formatter_f(w, s, d){
			var this_ = this;
			var list = this.COUPON_TRIGGER_TYPE;
			var list_list=[
				{
					code:"99",
					name:"receive",
					name_cn:"领取",
				},
				{
					code:"100",
					name:"Background distribution",
					name_cn:"后台发放",
				},
			]
			list=list.concat(list_list);
			var name = '';
			list.forEach(function (e, i) {
				if (e.code == d) {
					name = this_.lang == 'cn' ? e.name_cn : e.name;
				}
			});
			return name
		},
		is_use_f(w, s, d){
			var this_ = this;
			var list=[
				{
					code:"1",
					name:"YES",
					name_cn:"是",
				},
				{
					code:"0",
					name:"NO",
					name_cn:"否",
				},
			]
			var name = '';
			list.forEach(function (e, i) {
				if (e.code == d) {
					name = this_.lang == 'cn' ? e.name_cn : e.name;
				}
			});
			return name
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		exportCouponRecord(){
			var this_ = this;
			var TokenId = sessionStorage.getItem('TokenId');
			var lang = localStorage.getItem('lang') != 'cn' ? 'us' : 'cn';
			var url=process.env.API_ROOT+'/exportCouponRecord?TokenId=' + TokenId + '&language=' + lang + '&coupon_id=' + this_.data_data.id;
			console.log(url)
			window.open(url);
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	/* margin-bottom: 22px; */
}
.page-pagination {
	padding: 20px 10px;
}
.el-date-editor--datetimerange.el-input__inner.w100 {
	width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/coupon/index.vue